import { useState, useEffect } from 'react';
import { TaskItem } from '../interfaces/taskTile';
import { getValidateScheduledAssessmentDate } from '../../common/utils/dateFormatter';
import { INTERVIEW_LAUNCH_TIME, ONE_SECOND } from '../../constants/timers';
import moment from 'moment';
//import mtz from 'moment-timezone';
import { useTranslation } from 'react-i18next';

interface Timers {
  message: string;
  disabled: boolean;
}

export const useScheduledAssessmentTimerLayout02 = (scheduledTaskItem: TaskItem | null | undefined): Timers => {
  const { t } = useTranslation();
  const startTime =
    scheduledTaskItem && scheduledTaskItem.startTime
      ? getValidateScheduledAssessmentDate(scheduledTaskItem.startTime)
      : 0;
  const endTime =
    scheduledTaskItem && scheduledTaskItem.endTime ? getValidateScheduledAssessmentDate(scheduledTaskItem.endTime) : 0;
  const currentTime: number = new Date().getTime();
  const endTimer = endTime - currentTime;
  const [isEndTimerStarted, setEndTimerStarted] = useState(false);
  const startTimer = startTime - currentTime - INTERVIEW_LAUNCH_TIME;
  let initState = INTERVIEW_LAUNCH_TIME;
  const isBeforeAssessment = (): boolean =>
    moment(currentTime).isBefore(moment(startTime).subtract(INTERVIEW_LAUNCH_TIME));
  // when user enter during 15 min timer
  if (startTimer < 0 && startTimer > -INTERVIEW_LAUNCH_TIME) {
    initState = INTERVIEW_LAUNCH_TIME + startTimer;
  }
  // when additional 15 mins will pass and end time is not achived or simply assessment duration
  if (startTimer < 0 && startTimer < -INTERVIEW_LAUNCH_TIME) {
    initState = 0;
  }
  const [counter, setCounter] = useState(initState);
  const mins = moment.duration(counter - ONE_SECOND).minutes();
  const secs = moment.duration(counter - ONE_SECOND).seconds();
  const formatMins = moment().locale('EN_US').minutes(mins).format('mm');
  const formatSecs = moment().locale('EN_US').seconds(secs).format('ss');
  //const startTimeMsg = mtz.tz(startTime, mtz.tz.guess(true)).format('h:mmA z MM/DD/YYYY');
  const timerMsg = `${formatMins}:${formatSecs}`;

  useEffect(() => {
    setTimeout(() => {
      setCounter(initState);
    }, startTimer);
  }, [startTimer, counter, initState]);

  useEffect(() => {
    endTime &&
      counter <= 0 &&
      setTimeout(() => {
        setEndTimerStarted(true);
      }, endTimer);
  }, [counter, endTimer, endTime]);

  useEffect(() => {
    const timer: ReturnType<typeof setInterval> | false =
      counter > 0 &&
      setInterval(() => {
        setCounter(counter - ONE_SECOND);
      }, ONE_SECOND);
    if (timer) {
      return (): void => {
        clearInterval(timer);
      };
    }
  }, [initState, counter]);

  if (!scheduledTaskItem || !startTime) {
    return {
      message: '',
      disabled: false,
    };
  }
  // Before start & end time
  if (isEndTimerStarted === false && isBeforeAssessment()) {
    return {
      message: ``,
      disabled: true,
    };
  }
  if (counter <= 0 && isEndTimerStarted === false) {
    return { message: ``, disabled: false };
  } else if (counter <= 0 && isEndTimerStarted === true) {
    return { message: ``, disabled: true };
  }
  return {
    message: timerMsg === '00:00' ? `` : `${timerMsg} ${t('minuteAbbreviation')}`,
    disabled: false,
  };
};
